import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Colours from '@shared/ui/atoms/Colours';
import { BodySmall } from '@shared/ui/atoms/fonts/Body';
import { selectKiosk } from '../data/kiosk.duck';
import { PairingScreen } from '../components/PairingScreen';
import { KioskVisitorList } from '../components/KioskVisitorList';
import { KioskHeader } from '../components/KioskHeader';

export function KioskPage() {
  const kiosk = useSelector(selectKiosk);

  return (
    <Page>
      {kiosk.paired ? (
        <>
          <KioskHeader />
          <Main>
            <KioskVisitorList />
          </Main>
        </>
      ) : (
        <PairingWrapper>
          <PairingScreen />
        </PairingWrapper>
      )}
      <Footer>
        <BodySmall style={{ color: Colours.darkGrey }}>Powered by</BodySmall>
        <FooterLogo src="/assets/images/logos/team-today-logo.svg" alt="Team Today" />
      </Footer>
    </Page>
  );
}

const Page = styled.div`
  min-height: 100vh;
  background: ${Colours.veryLightGrey};
  display: flex;
  flex-direction: column;
`;

const Main = styled.div`
  flex: 1;
`;

const PairingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 0 24px;
  opacity: 0.75;
`;

const FooterLogo = styled.img`
  height: 18px;
  width: auto;
`;
